import Vue from 'vue'
import { projectFirestore } from '../firebase/config';
import appendHtml from 'appendhtml';
import { useRoute, } from 'vue-router';
const getGoogleTranslateIntegration = () => {
    const isGoogleTranslateIntegrations = (id) => {
        projectFirestore.collection('SupportLibraries').doc(id).get().then(async (doc) => {
            if (doc.exists) {
                let integrationsData = {...doc.data()}

                const customScript = (script) => {
                    const container = document.getElementById('integrationScript');
                    appendHtml(script, container);
                }


                if (integrationsData?.isGoolgeTranslateEnabled == true) {
                    let integration = `<script type="text/javascript">
                        function googleTranslateElementInit() {
                            new google.translate.TranslateElement({
                                pageLanguage: 'en', 
                                layout: google.translate.TranslateElement.InlineLayout.VERTICAL
                            }, 'modal_gtranslate');
                        }
                        </script>
                    
                        <script type="text/javascript" src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"></script>
                    `;
                    customScript(integration);
                    document.body.classList.add('g-translate')
                }
            }
        })
    }
    return {
        isGoogleTranslateIntegrations
    }
}

export default getGoogleTranslateIntegration

